module.exports = __webpack_public_path__ + "img/emo_50.3ff7ff37.png";